import animateNumber from '../general/plugins/animateNumber';
import { getLeadDimensions } from '../general/utils/ga4-tracking/custom-dimensions';
import { pushToDataLayer } from '../general/utils/ga4-tracking/push-to-data-layer';
import { getYobFromAge, getDateFromAge, getFirstOfNextMonth } from '../general/utils/date';
import { tariffBundleMarketingNames } from '../types/tariffs';

const tariffServiceUrl = window.backendApiUrl + '/tariff';
const pkvQqcForm = document.querySelector('form.pkvQQC');
const maxEmployerKv = pkvQqcForm ? parseFloat(pkvQqcForm.dataset.maxEmployerKv.replaceAll(',', '').replaceAll('.', '')) : 0;
const maxEmployerPv = pkvQqcForm ? parseFloat(pkvQqcForm.dataset.maxEmployerPv.replaceAll(',', '').replaceAll('.', '')) : 0;
const pkvQqcQuote = document.getElementById('quote');
const pkvContainer = document.querySelector('.quoteContainer');
const topupContainer = document.querySelector('.topupContainer');
const ageInputField = document.getElementById('ageInput');
const ctas = document.querySelectorAll('.list.qqc a');
let firstInteraction = false;
let qqcEventSent = false;

// SLIDE TOGGLE FOR TOPUP TAB IF NOT PKV ELIGBLE
function setQQCTab(showItem) {
  const oldActive = document.querySelector('.qqc > div.active');
  if (showItem !== oldActive) {
    oldActive.classList.add('hide');
    setTimeout(() => {
      oldActive.classList.remove('active', 'hide');
      showItem.classList.add('active', 'hide');
      setTimeout(() => {
        showItem.classList.add('show');
        setTimeout(() => {
          showItem.classList.remove('hide', 'show');
        }, 250);
      }, 50);
    }, 300);
  }
}
// SET AND ANIMATE TARIFF RATES
async function quoteCalc() {
  const age = parseInt(document.getElementById('ageInput').value);
  let employment = document.getElementById('employmentSelect').value;
  let income = document.getElementById('incomeSelect').value;

  if (age > 17 && age < 70) {
    if (income === 'over' || employment === 'self-employed') {
      pkvContainer.querySelectorAll('.gkv > span').forEach(span => {
        span.classList.add('hidden');
      });
      const pkvPriceFrom = pkvQqcQuote.notAnumber ? 238.7 : parseFloat(pkvQqcQuote.innerHTML.replace('€', '').replace('.', '').replace(',', '.').trim());
      pkvContainer.querySelector(`.gkv > span.${employment}`).classList.remove('hidden');
      setQQCTab(pkvContainer);
      //Get tariffpremiums async from tariff service already summed up
      const tariffData = await getTariffData(employment, age);
      let tariffPremium = tariffData?.tariffPremium;
      const premiumPlain = tariffData?.premiumPlain;
      const nursingCareShare = tariffData?.nursingCareShare;
      //split monthly premium in half for employed and get premiums from cent to euro
      if (tariffPremium) {
        if (employment === 'self-employed') {
          tariffPremium /= 100;
        } else {
          const tariffShare = Math.min((tariffPremium - nursingCareShare) / 2, maxEmployerKv);
          const pvShare = Math.min(nursingCareShare / 2, maxEmployerPv);
          tariffPremium = Math.floor(tariffPremium - (tariffShare + pvShare)) / 100;
        }
        animateNumber(
          value => {
            pkvQqcQuote.innerHTML = value.toFixed(2).replace(',', ':').replace('.', ',').replace(':', '.') + ' &euro;';
          },
          pkvPriceFrom,
          tariffPremium,
          850
        );
        // GA4 TRACKING
        if (firstInteraction && !qqcEventSent) {
          let contentSection = pkvContainer.closest('section');
          let section = contentSection ? contentSection.classList[0] : 'na';
          income = income === 'over' ? window.craftConfig.global.jaegReachedTracking : window.craftConfig.global.jaegNotReachedTracking;
          const jaeg_reached = income === window.craftConfig.global.jaegReachedTracking ? '1' : '0';
          pushToDataLayer({
            event: 'quick_quote_calculated',
            element_section: section,
            yob: getYobFromAge(age),
            tariff: tariffBundleMarketingNames['chi-business2019twin-10'],
            ...getLeadDimensions({ employment, income, jaeg_reached, insurance_category: 'full' }, { includeProduct: true })
          });
          qqcEventSent = true;
        }
      } else {
        pkvQqcQuote.innerHTML =
          "<div class='error'><strong> Oh nein, wir konnten den Preis nicht berechnen.</strong> <br/>Bitte lade die Seite neu und versuche es noch einmal oder kontaktiere uns über den Chat.</div>";
      }
    } else {
      setQQCTab(topupContainer);
    }
    updateCtasTracking(age, employment, income);
  }
}

function updateCtasTracking(age, employment, income) {
  ctas.forEach(cta => {
    cta.setAttribute('data-tr-yob', getYobFromAge(age));
    cta.setAttribute('data-tr-job_status', employment);
    cta.setAttribute('data-tr-income', income === 'over' ? window.craftConfig.global.jaegReachedTracking : window.craftConfig.global.jaegNotReachedTracking);
  });
}

ageInputField.addEventListener('click', e => {
  ageInputField.value = '';
});
// EVENT LISTENERS TO TRIGGER QQC CALCULATION ON VARIOUS USER INTERACTIONS
ageInputField.addEventListener('input', e => {
  if (document.getElementById('ageInput').value.length > 1) {
    setTimeout(() => {
      firstInteraction = true;
      quoteCalc();
    }, 800);
  }
});

document.getElementById('employmentSelect').addEventListener('change', e => {
  if (document.getElementById('ageInput').value.length > 1) {
    firstInteraction = true;
    quoteCalc();
  }
});

document.getElementById('incomeSelect').addEventListener('change', e => {
  if (document.getElementById('ageInput').value.length > 1) {
    firstInteraction = true;
    quoteCalc();
  }
});
// GET TARIFF PREIUMS FROM TARIFF SERVICE

const getTariffData = async (type, age) => {
  try {
    let dsa = type === 'employed' ? '43' : '42';
    const contributionRelief = (age < 21 ? '' : '&contribution_relief_from_age=67') + '&contribution_relief=100';
    const response = await fetch(
      `${tariffServiceUrl}/otto/quotes?occupational_status=${type}&date_of_birth=${getDateFromAge(
        age
      )}&tariff_excess=10&dsa_after_days=${dsa}&dsa_requested_payout=120&ingress_date=${getFirstOfNextMonth()}&tariff_name=business2019twin${age < 56 ? contributionRelief : ''}`
    );
    if (!response.ok) {
      return false;
    }
    const data = await response.json();
    const premiumPlain = data.find(d => d.name.includes('business2019twin'))?.premium || 0;
    const nursingCareShare = data.find(d => d.name.includes('cnci-normal'))?.premium || 0;
    let tariffData = data.map(tariff => parseInt(tariff.premium));
    let tariffPremium = 0;
    tariffData.forEach(premium => {
      tariffPremium += premium;
    });
    return { tariffPremium, premiumPlain, nursingCareShare };
  } catch (error) {
    return false;
  }
};

if (pkvQqcForm) {
  quoteCalc();
}
